import { SVG } from '@svgdotjs/svg.js'

function animateConultancyHeaderStart(){
    const consultancySvgBg = SVG(".consultancy-background svg");

    // Always animate
    const svgPathsAnimOnLoad = [
            '#branch-1-path-1',
            '#branch-2-path-1',
            '#branch-1-path-2',
            '#branch-1-path-3'
    ];

    svgPathsAnimOnLoad.forEach(function(pathId){
            var pathRef = SVG(pathId);
            pathRef.removeClass("hidden");
            pathRef.addClass("normalized-pathlengths");
            pathRef.addClass("path-anim-slow");
    });
}

export { animateConultancyHeaderStart }